"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialtiesArray = exports.SpecialtiesNames = exports.Specialties = void 0;
exports.Specialties = {
    FITNESS_CERTIFICATE: "aptofisico",
    AUDIOLOGY_OTONEUROLOGY_PHONIATRY: "audiologia_otoneurologia_foniatria",
    AUDIT: "auditoria",
    CARDIOLOGY: "cardiologia",
    SURGERY: "cirugia",
    INTERNAL_MEDICINE: "clinicamedica",
    DERMATOLOGY: "dermatologia",
    DIABETOLOGY: "diabetologia",
    ENDOCRINOLOGY: "endocrinologia",
    PHLEBOLOGY: "flebologia",
    GASTROENTEROLOGY: "gastroenterologia",
    GYNECOLOGY: "ginecologia",
    HEMATOLOGY: "hematologia",
    INTERNIST: "internista",
    SPORTS_MEDICINE: "medicina_del_deporte",
    FAMILY_MEDICINE: "medicinafamiliar",
    GENERAL_MEDICINE: "medicinageneral",
    OCCUPATIONAL_MEDICINE: "medicinalaboral",
    PULMONOLOGY: "neumonologia",
    NUTRITIONIST: "nutricionista",
    NEUROLOGY: "neurologia",
    OPHTHALMOLOGY: "oftalmologia",
    ONCOLOGY: "oncologia",
    OTORHINOLARYNGOLOGY: "otorrinolaringologia",
    PEDIATRICS: "pediatria",
    PSYCHOLOGY: "psicologia",
    PSYCHIATRY: "psiquiatria",
    RHEUMATOLOGY: "reumatologia",
    TRAUMATOLOGY: "traumatologia",
    UROLOGY: "urologia",
    PALLIATIVE_HOME_CARE: "paliativocuidadosdomiciliarios",
    PEDIATRIC_HOME_CARE: "pediatracuidadosdomiciliarios",
    CLINICAL_HOME_CARE: "clinicocuidadosdomiciliarios",
    EXECUTIVE_HEALTH_HOME_CARE: "ejecutivodesaludcuidadosdomiciliarios",
    PHARMACOVIGILANCE: "farmacovigilancia"
};
/* eslint-disable no-unused-vars */
exports.SpecialtiesNames = {
    aptofisico: "apto fisico",
    audiologia_otoneurologia_foniatria: "audiologia otoneurologia foniatria",
    auditoria: "auditoria",
    cardiologia: "cardiologia",
    cirugia: "cirugia",
    clinicamedica: "clinicamedica",
    dermatologia: "dermatologia",
    diabetologia: "diabetologia",
    endocrinologia: "endocrinologia",
    flebologia: "flebologia",
    gastroenterologia: "gastroenterologia",
    ginecologia: "ginecologia",
    hematologia: "hematologia",
    internista: "internista",
    medicina_del_deporte: "medicina del deporte",
    medicinafamiliar: "medicina familiar",
    medicinageneral: "medicina general",
    medicinalaboral: "medicina laboral",
    neumonologia: "neumonologia",
    nutricionista: "nutricionista",
    neurologia: "neurologia",
    oftalmologia: "oftalmologia",
    oncologia: "oncologia",
    otorrinolaringologia: "otorrinolaringologia",
    pediatria: "pediatria",
    psicologia: "psicologia",
    psiquiatria: "psiquiatria",
    reumatologia: "reumatologia",
    traumatologia: "traumatologia",
    urologia: "urologia",
    paliativocuidadosdomiciliarios: "paliativocuidadosdomiciliarios",
    pediatracuidadosdomiciliarios: "pediatracuidadosdomiciliarios",
    clinicocuidadosdomiciliarios: "clinicocuidadosdomiciliarios",
    ejecutivodesaludcuidadosdomiciliarios: "ejecutivodesaludcuidadosdomiciliarios",
    farmacovigilancia: "farmacovigilancia"
};
exports.specialtiesArray = [
    "aptofisico",
    "audiologia_otoneurologia_foniatria",
    "auditoria",
    "cardiologia",
    "cirugia",
    "clinicamedica",
    "dermatologia",
    "diabetologia",
    "endocrinologia",
    "flebologia",
    "gastroenterologia",
    "ginecologia",
    "hematologia",
    "internista",
    "medicina_del_deporte",
    "medicinafamiliar",
    "medicinageneral",
    "medicinalaboral",
    "neumonologia",
    "nutricionista",
    "neurologia",
    "oftalmologia",
    "oncologia",
    "otorrinolaringologia",
    "pediatria",
    "psicologia",
    "psiquiatria",
    "reumatologia",
    "traumatologia",
    "urologia",
    "paliativocuidadosdomiciliarios",
    "pediatracuidadosdomiciliarios",
    "clinicocuidadosdomiciliarios",
    "ejecutivodesaludcuidadosdomiciliarios",
    "farmacovigilancia"
];
